import React from 'react'
import Form from 'react-bootstrap/Form'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import { CRQ_FORM_FOCUS, MPxNS } from '../../common/constants'
import { identifierType } from '../../common/commonUtilities'

function useLoadedMPxN(props) {
  const desiredIdentifier = props.name.toUpperCase()
  if (!MPxNS.includes(desiredIdentifier)) {
    return null
  }
  const loadedIdentifier = document.getElementById('device-id').value
  return identifierType(loadedIdentifier) === desiredIdentifier
    ? loadedIdentifier
    : null
}

// Validates the field's pattern prop via setCustomValidity so that the check fires on
// <textarea> elements too (the HTML `pattern` attribute is ignored on textarea by browsers).
// Mirrors the SmartNumber.jsx pattern, with anchoring added so substring matches cannot
// pass (RegExp.test is unanchored; anchoring replicates native HTML5 pattern semantics).
function usePatternValidator(props) {
  if (!props.pattern) return undefined
  const anchored = new RegExp('^(?:' + props.pattern + ')$')
  return (e) => {
    e.target.setCustomValidity('')
    if (e.target.value.length === 0) return // let HTML `required` own the empty case
    if (!anchored.test(e.target.value)) {
      e.target.setCustomValidity(props.feedback)
    }
  }
}

//Generalised fragment for all variables that do not have fixed validation as a certain type to make consistent formatting
export default function SmartGeneral(props) {
  const validatePattern = usePatternValidator(props)
  return (
    <Form.Group as={Row} className="p-2">
      <Form.Label column sm="3">
        {props.label}
      </Form.Label>
      <Col sm="9" name={CRQ_FORM_FOCUS}>
        <Form.Control
          as={props.multiline ? 'textarea' : 'input'} // Use "textarea" if multiline is true
          name={props.name}
          id={props.name}
          placeholder={props.placeholder}
          required={props.required}
          pattern={props.pattern}
          title={props.title}
          size={props.size}
          maxLength={props.maxlength ?? props.maxLength}
          minLength={props.minlength ?? props.minLength}
          onInput={validatePattern}
          defaultValue={useLoadedMPxN(props) || props.defaultValue}
        />
        <Form.Control.Feedback type="invalid">
          {props.feedback}
        </Form.Control.Feedback>
      </Col>
    </Form.Group>
  )
}
